export enum ConnectionState {
  Connected = 'Connected',
  Connecting = 'Connecting',
  FailedToConnected = 'FailedToConnected',
  Disconnected = 'Disconnected',
}

export enum ConnectionFeedback {
  Connected = 'Connected',
  ConnectionFailed = 'ConnectionFailed',
}
